import React, { useState } from "react";
import { AiTwotoneSetting } from "@react-icons/all-files/ai/AiTwotoneSetting";

function ChapterSetting({
  currentColor,
  setCurrentColor,
  currentSize,
  setCurrentSize,
}) {
  const [popUp, setPopUp] = useState(false);
  const handleClick1 = () => {
    setCurrentColor(1);
    localStorage.setItem("ChapterTheme", 1);
  };
  const handleClick2 = () => {
    setCurrentColor(2);
    localStorage.setItem("ChapterTheme", 2);
  };
  const handleClick3 = () => {
    setCurrentColor(3);
    localStorage.setItem("ChapterTheme", 3);
  };

  const handleClick001 = () => {
    if (currentSize > 14) {
      setCurrentSize((prev) => prev - 2);
    }
  };
  const handleClick003 = () => {
    if (currentSize < 25) {
      setCurrentSize((prev) => prev + 2);
    }
  };
  return (
    <div>
      {/* popup */}
      <div
        onClick={() => {
          setPopUp(false);
        }}
        className={
          popUp
            ? "absolute top-0 left-0 right-0 bottom-0 h-[150vh] w-full  purple-full-width bg-secondary/0 opacity-100 duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width bg-secondary/0 top-0 left-0 h-[150vh] opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      <div
        onClick={() => setPopUp((prev) => !prev)}
        className="w-14 h-14 cursor-pointer group bg-primary hover:bg-primary/80 duration-500 ease-in-out absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2  flex justify-center items-center rounded-full"
      >
        <div className="">
          <AiTwotoneSetting className="text-[20px] text-tertiary group-hover:text-tertiary/80 duration-500 ease-in-out " />
        </div>
      </div>
      <div
        className={
          !popUp
            ? "w-[95%] md:w-[70%] lg:w-1/2 h-auto bg-primary absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[130%]  opacity-0 duration-500 ease-in-out pointer-events-none"
            : "w-[95%] md:w-[70%] lg:w-1/2 h-auto bg-primary absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[115%]  opacity-1 duration-500 ease-in-out pointer-events-auto"
        }
      >
        <div className="flex flex-col justify-center items-center">
          <h2 className="text-tertiary uppercase p-6 font-SoraR">
            Display Options
          </h2>
          <div className="w-full h-[1px] bg-tertiary/50"></div>
        </div>
        <div className="w-full h-full px-[15px] md:px-6 py-10 gap-y-8 flex flex-col">
          <div className="gap-y-4 w-full h-full flex flex-col ">
            <div>
              <p className=" font-SoraR capitalize text-tertiary">background</p>
            </div>
            <div className="w-full h-full flex gap-x-4">
              <div
                onClick={handleClick1}
                className={
                  currentColor === 1
                    ? "w-1/2 h-[50px] duration-500 ease-in-out bg-[#282435] cursor-pointer"
                    : currentColor === 2
                    ? "w-1/4 h-[50px] duration-500 ease-in-out bg-[#282435] cursor-pointer"
                    : "w-1/4 h-[50px] duration-500 ease-in-out bg-[#282435] cursor-pointer"
                }
              ></div>
              <div
                onClick={handleClick2}
                className={
                  currentColor === 1
                    ? "w-1/4 h-[50px] duration-500 ease-in-out bg-primarys cursor-pointer"
                    : currentColor === 2
                    ? "w-1/2 h-[50px] duration-500 ease-in-out bg-primarys cursor-pointer"
                    : "w-1/4 h-[50px] duration-500 ease-in-out bg-primarys cursor-pointer"
                }
              ></div>
              <div
                onClick={handleClick3}
                className={
                  currentColor === 1
                    ? "w-1/4 h-[50px] duration-500 ease-in-out bg-[#FFFBE6] cursor-pointer"
                    : currentColor === 2
                    ? "w-1/4 h-[50px] duration-500 ease-in-out bg-[#FFFBE6] cursor-pointer"
                    : "w-1/2 h-[50px] duration-500 ease-in-out bg-[#FFFBE6] cursor-pointer"
                }
              ></div>
            </div>
          </div>
          <div className="gap-y-4  w-full h-full flex flex-col ">
            <div>
              <p className=" font-SoraR capitalize text-tertiary">FontSize</p>
            </div>
            <div className="w-full h-full flex  border-[1px] border-secondary justify-center items-center text-center ">
              <div
                onClick={handleClick001}
                className=" font-SoraS cursor-pointer hover:bg-secondary text-tertiary duration-500 ease-in-out w-1/4 h-[50px] uppercase flex justify-center items-center"
              >
                a-
              </div>
              <div className=" font-SoraS cursor-pointer hover:bg-secondary text-tertiary duration-500 ease-in-out w-1/2 h-[50px] uppercase border-r-[1px] border-l-[1px] border-secondary flex justify-center items-center">
                {currentSize}
              </div>
              <div
                onClick={handleClick003}
                className=" font-SoraS cursor-pointer hover:bg-secondary text-tertiary duration-500 ease-in-out w-1/4 h-[50px] uppercase flex justify-center items-center"
              >
                a+
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChapterSetting;
